<div class="modal-dialog compare-products-dialog goreact-modal">
  <div>
    <span class="modal-squiggle"></span>
    <div class="goreact-modal-header">
      <span>
        @if (transactionType === transactionTypes.TRIAL_END) {
          <h4 [id]="data.dialogTitleId" class="modal-title" translate="product-compare_trial-ended"></h4>
        } @else {
          <span [id]="data.dialogTitleId" class="cdk-visually-hidden" translate="license-plan-upgrade-license"></span>
        }
      </span>
      <button type="button" class="tertiary-btn close-icon" (click)="close()" attr.aria-label="{{ 'common_close' | translate }}">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body">
      @for (product of products; track product; let last = $last) {
        <product-card
          [product]="product"
          [actionTranslation]="product.actionTranslation"
          [isDisabled]="!product.hasAction"
          [isLast]="last"
          [trialEnded]="transactionType === transactionTypes.TRIAL_END"
          [hidePrice]="data.launchAsNonAdminRequest"
        (action)="selectPackage(product)"></product-card>
      }
    </div>
    <div class="goreact-modal-footer">
      @if (!data.launchAsNonAdminRequest && data.license != null) {
        <div>
          <span class="product-compare-contact-sales-label">{{ 'product-compare_volume_based_discount_available' | translate }}</span>
          <button class="link-btn product-compare-contact-sales-btn" (click)="handleContactSalesClick()">
            {{ 'product-compare_contact_sales' | translate }}
            @if (isContactSalesRequestLoading) {
              <div class="loading-bar-spinner">
                <span class="ficon-spinner ficon-spin"></span>
              </div>
            }
          </button>
        </div>
      }
      <button class="tertiary-btn close-btn" (click)="close()">{{ 'common_close' | translate }}</button>
    </div>
  </div>
</div>
